import React from 'react';
import { motion } from 'framer-motion';
import { getFearMessageWithDefaults } from '../config/gameConfig';

const GameOverScreen = ({ fearMessage, onRestartLevel, onBackToMenu }) => {
  const message = getFearMessageWithDefaults(fearMessage);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-white font-mono relative overflow-hidden py-8">
      {/* Glitchy Background */}
      <div className="absolute inset-0 opacity-20 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] brightness-50 contrast-150"></div>
      <div className="absolute inset-0 border-[20px] border-red-900/10 pointer-events-none"></div>

      <motion.div
        className="max-w-2xl w-full p-8 z-10 text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, type: "spring" }}
          className="mb-8"
        >
          <h1 className="text-6xl font-bold text-red-600 tracking-tighter uppercase mb-2">
            {message.header}
          </h1>
          <div className="h-0.5 w-32 bg-red-600 mx-auto"></div>
        </motion.div>

        <motion.div
          className="bg-black/80 border border-red-900/50 p-8 mb-10 relative"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          {/* Tech decorative corners */}
          <div className="absolute top-0 left-0 w-2 h-2 bg-red-600"></div>
          <div className="absolute top-0 right-0 w-2 h-2 bg-red-600"></div>
          <div className="absolute bottom-0 left-0 w-2 h-2 bg-red-600"></div>
          <div className="absolute bottom-0 right-0 w-2 h-2 bg-red-600"></div>

          <div className="text-red-400 text-xs uppercase tracking-[0.2em] mb-4">
            {message.name}
          </div>

          <div className="text-xl md:text-2xl text-gray-300 font-light italic">
            {message.message}
          </div>
        </motion.div>

        <div className="flex flex-col sm:flex-row justify-center gap-6">
          <motion.button
            onClick={onRestartLevel}
            className="px-8 py-4 bg-red-900/20 border border-red-600/50 text-white font-bold uppercase tracking-widest hover:bg-red-600 hover:text-black transition-all duration-300"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 }}
          >
            {message.restartButton}
          </motion.button>

          <motion.button
            onClick={onBackToMenu}
            className="px-8 py-4 bg-transparent border border-gray-700 text-gray-400 font-bold uppercase tracking-widest hover:border-gray-500 hover:text-white transition-all duration-300"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
          >
            {message.menuButton}
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default GameOverScreen;